export const frontEndConstants = {
	LOGIN_MUSIC_DIRECTOR_REQUEST	: 'LOGIN_MUSIC_DIRECTOR_REQUEST',
	LOGIN_MUSIC_DIRECTOR_SUCCESS	: 'LOGIN_MUSIC_DIRECTOR_SUCCESS',
	LOGIN_MUSIC_DIRECTOR_FAILURE	: 'LOGIN_MUSIC_DIRECTOR_FAILURE',
	
	LOGOUT_MUSIC_DIRECTOR 			: 'LOGOUT_MUSIC_DIRECTOR',
	
	GET_ADJUDICATORS_REQUEST : 'GET_ADJUDICATORS_REQUEST',
	GET_ADJUDICATORS_SUCCESS : 'GET_ADJUDICATORS_SUCCESS',
	GET_ADJUDICATORS_FAILURE : 'GET_ADJUDICATORS_FAILURE',

	GET_ADJUDICATORS_RECORDINGS_REQUEST : 'GET_ADJUDICATORS_RECORDINGS_REQUEST',
	GET_ADJUDICATORS_RECORDINGS_SUCCESS : 'GET_ADJUDICATORS_RECORDINGS_SUCCESS',
	GET_ADJUDICATORS_RECORDINGS_FAILURE : 'GET_ADJUDICATORS_RECORDINGS_FAILURE',


	FORGET_MUSIC_DIRECTOR_REQUEST	: 'FORGET_MUSIC_DIRECTOR_REQUEST',
	FORGET_MUSIC_DIRECTOR_SUCCESS	: 'FORGET_MUSIC_DIRECTOR_SUCCESS',
	FORGET_MUSIC_DIRECTOR_FAILURE	: 'FORGET_MUSIC_DIRECTOR_FAILURE',

	GET_ALL_TESTIMONIALS_REQUEST: "GET_ALL_TESTIMONIALS_REQUEST",
	GET_ALL_TESTIMONIALS_SUCCESS: "GET_ALL_TESTIMONIALS_SUCCESS",
	GET_ALL_TESTIMONIALS_FAILURE: "GET_ALL_TESTIMONIALS_FAILURE",

  	STORE_TESTIMONAIL_SUCCESS: "STORE_TESTIMONAIL_SUCCESS",
  	STORE_TESTIMONAIL_FAILURE: "STORE_TESTIMONAIL_FAILURE",
};


// WEBPACK FOOTER //
// ./src/redux/constant/front-end-constant.jsx